module.exports = __webpack_public_path__ + "img/Logos-EJ-pirelli.95a04f1f.jpg";